import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Footer from './components/Footer/Footer';
import Navbar from './components/Navbar/Navbar';
import AuthProvider from './contexts/AuthProvider';
import OrderProvider from './contexts/OrderProvider';
import PrivateRoute from './routes/PrivateRoute';
import PublicRoute from './routes/PublicRoute';
import ContactScreen from './screens/ContactScreen';
import ErrorScreen from './screens/ErrorScreen';
import HomeScreen from './screens/HomeScreen';
import OrderScreen from './screens/OrderScreen';
import ProductDetailScreen from './screens/ProductDetailScreen';
import ProductsScreen from './screens/ProductsScreen';
import ServicesDetailScreen from './screens/ServicesDetailScreen';
import SignInScreen from './screens/SignInScreen';
import SignUpScreen from './screens/SignUpScreen';
import ForgetPasswordScreen from './screens/ForgetPasswordScreen';
import AdminRoute from './routes/AdminRoute';
import AdminDashboard from './Admin/AdminDashboard';
import CategoriesScreen from './Admin/screens/CategoriesScreen';
import SubCategoriesScreen from './Admin/screens/SubCategoriesScreen';
import ProductsAdminScreen from './Admin/screens/ProductsScreen';
import SettingsScreen from './Admin/screens/SettingsScreen';
import ReportsScreen from './Admin/screens/ReportsScreen';
import UtilisateursScreen from './Admin/screens/UtilisateursScreen';
import ScrollToTop from './components/ScrollToTop'; 
import PromoProductsAdminScreen from './Admin/screens/PromoProductsScreen';
import CommandesScreen from './Admin/screens/CommandesScreen';
import CheckoutPage from './screens/CheckoutPage';
import OrdersHistoryScreen from './screens/OrdersHistoryScreen';

const Layout = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  return (
    <>
      {!isAdminRoute && <Navbar />}
      {children}
      {!isAdminRoute && <Footer />}
    </>
  );
};

if (process.env.NODE_ENV === 'production') {
  if (typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ === 'object') {
    for (let [key, value] of Object.entries(window.__REACT_DEVTOOLS_GLOBAL_HOOK__)) {
      window.__REACT_DEVTOOLS_GLOBAL_HOOK__[key] = typeof value === 'function' ? () => {} : null;
    }
  }
  console.log = function () {};
  console.warn = function () {};
  console.error = function () {};
  console.info = function () {};
  document.addEventListener('contextmenu', e => e.preventDefault());
  document.addEventListener('keydown', e => {
    if (
      (e.ctrlKey && e.shiftKey && ['I', 'C', 'J'].includes(e.key.toUpperCase())) ||
      (e.ctrlKey && e.key.toUpperCase() === 'U')
    ) {
      e.preventDefault();
    }
  });
}

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop /> 
      <AuthProvider>
        <OrderProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<HomeScreen />} />
              <Route path="/contact" element={<ContactScreen />} />
              <Route path="/signup" element={<PublicRoute><SignUpScreen /></PublicRoute>} />
              <Route path="/signin" element={<PublicRoute><SignInScreen /></PublicRoute>} />
              <Route path="/forgetpassword" element={<PublicRoute><ForgetPasswordScreen /></PublicRoute>} />
              <Route path="/services/:title" element={<PrivateRoute><ServicesDetailScreen /></PrivateRoute>} />
              <Route path="/products" element={<ProductsScreen />} />
              <Route path="/products/view/:name" element={<PrivateRoute><ProductDetailScreen /></PrivateRoute>} />
              <Route path="/checkout" element={<PrivateRoute><CheckoutPage /></PrivateRoute>} />
              <Route path="/orders" element={<PrivateRoute><OrderScreen /></PrivateRoute>} />
              <Route path="/historique-commandes" element={<PrivateRoute><OrdersHistoryScreen /></PrivateRoute>} />
              <Route path="/admin/:slug" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
              <Route path="/admin/:slug/categories" element={<AdminRoute><CategoriesScreen /></AdminRoute>} />
              <Route path="/admin/:slug/sous-categories" element={<AdminRoute><SubCategoriesScreen /></AdminRoute>} />
              <Route path="/admin/:slug/produits" element={<AdminRoute><ProductsAdminScreen /></AdminRoute>} />
              <Route path="/admin/:slug/produits-promo" element={<AdminRoute><PromoProductsAdminScreen /></AdminRoute>} />
              <Route path="/admin/:slug/parametres" element={<AdminRoute><SettingsScreen /></AdminRoute>} />
              <Route path="/admin/:slug/rapports" element={<AdminRoute><ReportsScreen /></AdminRoute>} />
              <Route path="/admin/:slug/commandes" element={<AdminRoute><CommandesScreen /></AdminRoute>} />
              <Route path="/admin/:slug/utilisateurs" element={<AdminRoute><UtilisateursScreen /></AdminRoute>} />
              <Route path="*" element={<ErrorScreen />} />
            </Routes>
          </Layout>
        </OrderProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
